export default "/WebApp/dist/assets/images/chess.jpg";